/**
 * WHAT: decides whether a machine's status dot should render red.
 *
 * WHY this shape: the machines-list API returns `last_scan_status` as a
 * plain boolean — `false` means the machine's last scan errored, `true`
 * means it succeeded. There's no string enum to pattern-match against
 * (that was an earlier, incorrect assumption about the payload shape).
 *
 * GOTCHA: `false` is a valid, meaningful value here — don't rewrite this
 * with `if (!machine?.last_scan_status) return false`, that would also
 * swallow the real `false` case and always report "success". We explicitly
 * distinguish "field is false" (error) from "field is missing" (unknown →
 * treated as success, since we have nothing to show an error for).
 */
export const isMachineError = (machine: any): boolean => {
  const lastScanStatus: boolean | undefined = machine?.last_scan_status;
  if (lastScanStatus === undefined || lastScanStatus === null) return false;
  return lastScanStatus === false;
};

/**
 * Logs are newest-first (matches the existing EOD log table's convention).
 * A machine is "in error" for sidebar/status purposes when its most recent
 * log entry has category or status "ERROR" (case-insensitive) — these two
 * fields are confirmed real/current fields on the logs response.
 */
export const isLatestLogError = (logs: any[] | undefined | null): boolean => {
  if (!logs || logs.length === 0) return false;
  const latest = logs[0];
  return (
    latest?.category?.toString().toUpperCase() === "ERROR" ||
    latest?.status?.toString().toUpperCase() === "ERROR"
  );
};
